module.exports = __webpack_public_path__ + "img/img_dontai.f0f9bc3a.jpg";